import {Loader} from 'google-maps';

class GoogleMap {
    static init () {
        return new Promise(function (resolve, reject) {
            try {
                const options =  {
                    LIBRARIES: ['drawing', 'places'],
                    LANGUAGE: ['uk'],
                    VERSION: 'weekly'
                };
                const loader = new Loader('AIzaSyBh5pjyr7g-9WKLbdZBPcrT3H6V3FEGj_Q', options);

                loader.load().then(google => {
                    resolve(google);
                })
            } catch (error) {
                reject(error)
            }
        });
    }
}

export {GoogleMap};